<template>
    <button
        type="button"
        class="o-qr-scanner-button"
        @click="onClickHandler"
    >
        <svg-icon
            original
            name="icons/poster-category"
            class="qr-icon"
        />
        <span>
            {{ TRANSLATIONS.START_POSITION_POSTER }}
        </span>
    </button>
</template>

<script>
export default {
    name: 'OQRScannerButton',
    computed: {
        TRANSLATIONS() {
            return {
                START_POSITION_POSTER: this.$t('ui.poster-category')
            }
        }
    },
    setup(props, { emit }) {
        function onClickHandler() {
            emit('onClick');
        }

        return {
            onClickHandler
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />